import { useQuery } from 'react-query';
import { QueryKey } from '../constants/queryKey';
import useApi from '../api';
import queryConfig from '../util/queryConfig';

const useUsers = () => {
    const { getUsers } = useApi();

    const query = useQuery([QueryKey.Users], async () => {
        const response = await getUsers();
        return response.data;
    }, queryConfig);

    const { data, isLoading, isError, isFetched } = query;

    return {
        users: data?.users,
        isLoading,
        isFetched,
        isError,
    };
};

export default useUsers;
